"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientCoordinatesFromEvent = exports.getPageCoordinatesFromEvent = void 0;

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var getPageCoordinatesFromEvent = function getPageCoordinatesFromEvent(evt) {
  var x = evt.pageX;
  var y = evt.pageY;

  if (evt.touches && evt.touches.length > 0) {
    x = evt.touches[0].pageX;
    y = evt.touches[0].pageY;
  } else if (evt.changedTouches && evt.changedTouches.length > 0) {
    x = evt.changedTouches[0].pageX;
    y = evt.changedTouches[0].pageY;
  }

  return {
    x: x,
    y: y
  };
};

exports.getPageCoordinatesFromEvent = getPageCoordinatesFromEvent;

var getClientCoordinatesFromEvent = function getClientCoordinatesFromEvent(evt) {
  var x = evt.clientX;
  var y = evt.clientY;

  if (evt.changedTouches && evt.changedTouches.length > 0) {
    x = evt.changedTouches[0].clientX;
    y = evt.changedTouches[0].clientY;
  }

  return {
    x: x,
    y: y
  };
};

exports.getClientCoordinatesFromEvent = getClientCoordinatesFromEvent;